import moment from "moment";

export const iOS: () => boolean = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isDesktopWindow = (width: number) => width > 1050;
export const isTabletWindow = (width: number) => width > 768 && width < 1050;

export const formatGameMinute = (event, withSeconds = false) => {
    if (!event.time) return null;
    const currentPeriodStartTime = moment.unix(
        event.time.currentPeriodStartTimestamp || event.startTimestamp
    );
    const currentTime = moment();

    // Calculate elapsed time in seconds
    const elapsedTimeSeconds = currentTime.diff(currentPeriodStartTime, 'seconds');

    // Initialize period minute offset and period duration
    let periodMinuteOffset = 0;
    let periodDuration = 45; // Default duration for halves

    // Determine the period and set minute offset and duration accordingly
    const statusDescription = event.status?.description?.toLowerCase();

    if (statusDescription.includes('1st half')) {
        periodMinuteOffset = 0;
        periodDuration = 45;
    } else if (statusDescription.includes('2nd half')) {
        periodMinuteOffset = 45;
        periodDuration = 45;
    } else if (statusDescription.includes('1st extra')) {
        periodMinuteOffset = 90;
        periodDuration = 15;
    } else if (statusDescription.includes('2nd extra')) {
        periodMinuteOffset = 105;
        periodDuration = 15;
    } else if (statusDescription.includes('penalties')) {
        periodMinuteOffset = 120;
        periodDuration = 0; // Penalties have no standard duration
    } else if (statusDescription.includes('halftime')) {
        // Halftime, use last period's standard length
        periodMinuteOffset = 45;
        periodDuration = 0;
    } else if (
        statusDescription.includes('ft') ||
        statusDescription.includes('fulltime') ||
        statusDescription.includes('ended')
    ) {
        // Full time
        periodMinuteOffset = 90;
        periodDuration = 0;
    } else if (statusDescription.includes('notstarted')) {
        // Not started
        periodMinuteOffset = 0;
        periodDuration = 0;
    } else {
        // Default to first half if unknown
        periodMinuteOffset = 0;
        periodDuration = 45;
    }

    // Calculate any initial offset in minutes (if applicable)
    const initialOffsetMinutes = event.time.initial / 60 ? event.time.initial / 60 : 0;

    // Calculate current minute and second
    let currentMinute = periodMinuteOffset + Math.floor(elapsedTimeSeconds / 60) + initialOffsetMinutes;
    let currentSecond = elapsedTimeSeconds % 60;

    // Format the result
    const resMinute = Math.floor(currentMinute);
    const resSecond = String(currentSecond).padStart(2, '0'); // Ensure two digits for seconds

    // Return result based on withSeconds flag
    if (withSeconds) {
        return `${resMinute}:${resSecond}`;
    }

    // Calculate standard period end minute
    const standardPeriodEndMinute = periodMinuteOffset + periodDuration;

    // Handle added time (extra minutes beyond standard period length)
    if (resMinute > standardPeriodEndMinute && periodDuration > 0) {
        const addedTime = resMinute - standardPeriodEndMinute;
        return `${standardPeriodEndMinute}+${addedTime}`;
    } else {
        return resMinute.toString();
    }
};


export const convertToTitleCase = (str: string) => {
    return str
        .split(/(?=[A-Z])/)          // Split string at each uppercase letter
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize first letter
        .join(' ');                  // Join words with a space
}

export const ODDS_TAB_INDEX = 0;
export const STATISTICS_TAB_INDEX = 1;
export const H2H_TAB_INDEX = 2;
export const EVENTS_TAB_INDEX = 3;
export const ANALYSIS_TAB_INDEX = 4;

export const FETCH_INTERVAL = 20000